module.exports = __webpack_public_path__ + "img/reach-banner-3.14491ce1.jpg";